/**
 * Lookup values for Vehicle Pursuits module
 * 
 * These values represent the unique values that can be used when generating mock data.
 */

/**
 * Unique values for InitialReasonForPursuit
 * Top 12 most commonly used values from source data
 */
export const INITIAL_REASON_VALUES: readonly string[] = [
  'Traffic Violation',
  'Traffic violation',
  'Traffic Violation (Not DUI)',
  'Other',
  'Felony',
  'Other (Explain in Narrative)',
  'Stolen Vehicle',
  'Traffic Crime',
  'Wanted Subject',
  'Traffic Infraction',
  'Misdemeanor',
  'Felony - Committed',
] as const;

/**
 * Unique values for HowWasThePursuitTerminated
 * Top 12 most commonly used values from source data
 */
export const HOW_TERMINATED_VALUES: readonly string[] = [
  'Suspect stopped vehicle',
  'Suspect vehicle crashed',
  'Suspect vehicle eluded pursuit',
  'Suspect vehicle voluntarily stopped',
  'Public safety',
  'Dry',
  'Terminated for the Safety of the Public',
  'Suspect abandoned vehicle and fled on foot',
  'Offender Stopped',
  'Other',
  'Suspect vehicle became involved in a collision',
  'Pursuit aborted by law enforcement agency',
] as const;

/**
 * Unique values for TerminationTactics
 * Top 12 most commonly used values from source data
 */
export const TERMINATION_TACTIC_VALUES: readonly string[] = [
  'None',
  'PIT',
  'Spike Strips',
  'Stop Sticks',
  'N/A',
  'No',
  'Driver Stopped Vehicle',
  'Other',
  'Not Applicable',
  'NONE USED',
  'Other (Explain in Narrative)',
  'Trailing',
] as const;
